if (!customElements.get('quick-add-modal')) {
    customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
        constructor() {
            super();
            this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        }

        hide(preventFocus = false) {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
            this.modalContent.innerHTML = '';
            if (preventFocus) this.openedBy = null;
            super.hide();
        }

        show(opener) {
            opener.setAttribute('aria-disabled', true);
            opener.classList.add('loading');

            if (opener.querySelector('.loading-overlay__spinner')) {
                opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
            }

            fetch(opener.getAttribute('data-product-url'))
                .then((response) => response.text())
                .then((responseText) => {
                    const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                    this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

                    // 1. POSITION DESCRIPTION
                    const title = this.productElement.querySelector('.product__title');
                    const desc = this.productElement.querySelector('.product__description, .rte');
                    if (title && desc) {
                        title.after(desc);
                        desc.style.display = 'block';
                        desc.style.marginTop = '20px';
                    }

                    // 2. HIDE ARTIST NAME & "ORIGINAL PIECE"
                    // We target the specific text blocks Portland uses for metadata
                    const metadata = this.productElement.querySelectorAll('.product__text, .caption, .subtitle, .product__view-details');
                    metadata.forEach(el => {
                        // If it's not the description we just moved, get rid of it
                        if (el !== desc && !el.contains(desc)) {
                            el.style.display = 'none';
                            el.remove();
                        }
                    });

                    this.preventDuplicatedIDs();
                    this.removeDOMElements();
                    this.setInnerHTML(this.modalContent, this.productElement.innerHTML, opener);

                    if (window.Shopify && Shopify.PaymentButton) {
                        Shopify.PaymentButton.init();
                    }

                    this.removeGalleryListSemantic();
                    this.updateImageSizes();
                    this.preventVariantURLSwitching();
                    super.show(opener);
                })
                .finally(() => {
                    opener.removeAttribute('aria-disabled');
                    opener.classList.remove('loading');

                    if (opener.querySelector('.loading-overlay__spinner')) {
                        opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
                    }

                    var slider = new Swiper('.quick-add-modal .js-media-list', {
                        slidesPerView: 1,
                        autoHeight: true,
                        navigation: {
                            nextEl: '.swiper-btn--next',
                            prevEl: '.swiper-btn--prev',
                        },
                    });
                });
        }

        setInnerHTML(element, html, opener) {
            element.innerHTML = html;

            // 3. FIX BUTTONS (Removes Add to Cart & Enquire, adds single View Details button)
            const productUrl = opener.getAttribute('data-product-url');
            const buttonWrapper = element.querySelector('.product-form__buttons');
            const entireForm = element.querySelector('product-form');

            if (buttonWrapper) {
                // Replace the inner buttons but keep the wrapper for styling
                buttonWrapper.innerHTML = `
                    <a href="${productUrl}" class="button button--full-width button--primary" style="display: flex; justify-content: center; align-items: center; text-decoration: none;">
                        View Product Details
                    </a>
                `;
            } else if (entireForm) {
                // Backup if the wrapper isn't found
                entireForm.innerHTML = `
                    <div class="product-form__buttons">
                        <a href="${productUrl}" class="button button--full-width button--primary" style="display: flex; justify-content: center; align-items: center; text-decoration: none;">
                            View Product Details
                        </a>
                    </div>
                `;
            }

            // Remove any stray Enquire buttons or "Full Details" links that might be outside the form
            element.querySelectorAll('.product__read-more, .enquire-button, [href*="contact"]').forEach(el => el.remove());

            element.querySelectorAll('script').forEach(oldScriptTag => {
                const newScriptTag = document.createElement('script');
                Array.from(oldScriptTag.attributes).forEach(attribute => {
                    newScriptTag.setAttribute(attribute.name, attribute.value)
                });
                newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
                oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
            });
        }

        removeDOMElements() {
            const selectors = [
                'product-modal', 
                '.breadcrumb', 
                'pickup-availability', 
                '.product-popup', 
                '.customer', 
                '.share-buttons',
                '.about__accordion-item',
                '.product__tax' // Hides "Shipping calculated at checkout"
            ];
            selectors.forEach(selector => {
                this.productElement.querySelectorAll(selector).forEach(el => el.remove());
            });
        }

        preventDuplicatedIDs() {
            const sectionId = this.productElement.dataset.section;
            this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
        }

        preventVariantURLSwitching() {
            if (this.modalContent.querySelector('variant-radios,variant-selects')) {
                this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
            }
        }

        removeGalleryListSemantic() {
            const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
            if (!galleryList) return;
            galleryList.setAttribute('role', 'presentation');
            galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
        }

        updateImageSizes() {
            const product = this.modalContent.querySelector('.product');
            if (!product) return;
            const mediaImages = product.querySelectorAll('.product__media img');
            mediaImages.forEach(img => img.setAttribute('sizes', '(min-width: 1000px) 715px, 100vw'));
        }
    });
}